/**
 * States where a Coyote Creek hat has been sold.
 *
 * 👉 To add a new state: append its full name (matching US Census naming)
 *    to this array and save. The Range Map page will pick it up on next refresh.
 *
 * Keep names in Title Case, exactly as the US Census Bureau lists them
 * (e.g. "North Carolina", not "N. Carolina" or "NC").
 */
export const SOLD_STATES: string[] = [
  "Texas",
  "South Carolina",
  "California",
  "Ohio",
  "Georgia",
  "Colorado",
  "New Mexico",
  "Arizona",
  "Oklahoma",
  "Florida",
  "Oregon",
  "Tennessee",
  "Virginia",
  "West Virginia",
  "Utah",
  "Arkansas",
  "Alabama",
  "Missouri",
  "Idaho",
  "North Carolina",
  "Wisconsin",
  "Minnesota",
  "Mississippi",
  "Kansas",
  "Wyoming",
  "Illinois",
  "Montana",
  "Louisiana",
  "New York",
  "Washington",
  "Nebraska",
  "Massachusetts",
  "New Jersey",
  "Iowa",
  "Indiana",
];

/** Origin city for the animated arcs — Coyote Creek HQ. */
export const ORIGIN = {
  name: "Houston, TX",
  coordinates: [-95.3698, 29.7604] as [number, number],
};
